import { AdminUserCreatePage } from "@/features/admin-user/pages/AdminUserCreate";
import React from "react";

const AdminUserCreate = () => {
  return <AdminUserCreatePage />;
};

export default AdminUserCreate;
